import { render, staticRenderFns } from "./smsVerification.vue?vue&type=template&id=0fec0bdc"
import script from "./smsVerification.vue?vue&type=script&lang=js"
export * from "./smsVerification.vue?vue&type=script&lang=js"
import style0 from "./smsVerification.vue?vue&type=style&index=0&id=0fec0bdc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports